webpackJsonp([142504720629826],{

/***/ 1590:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/it/master/","langKey":"it"}}

/***/ })

});


// WEBPACK FOOTER //
// path---it-master-47b3735a3cacc448bf02.js